export const FEATURE_NAME = '@zerops/zerops/feature/version-notification';
